import { render, staticRenderFns } from "./EmployeeBonus.vue?vue&type=template&id=4fc87faa&"
import script from "./EmployeeBonus.vue?vue&type=script&lang=js&"
export * from "./EmployeeBonus.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeBonus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc87faa')) {
      api.createRecord('4fc87faa', component.options)
    } else {
      api.reload('4fc87faa', component.options)
    }
    module.hot.accept("./EmployeeBonus.vue?vue&type=template&id=4fc87faa&", function () {
      api.rerender('4fc87faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/GuideChildren/KpidataChildren/EmployeeBonus.vue"
export default component.exports